import { getCouponList } from 'model/coupon';
import { getUser } from 'model/user';

export default store => ({
	path: 'coupon',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Coupon',
			),
		onEnter: () => {
			store.dispatch(getCouponList());
			store.dispatch(getUser());
		},
	},
});
